export const GET_FORM16_DATA_LOADING = "GET_FORM16_DATA_LOADING";
export const GET_FORM16_DATA_SUCCESS = "GET_FORM16_DATA_SUCCESS";
export const GET_FORM16_DATA_FAILED = "GET_FORM16_DATA_FAILED";
